import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-provider-profile-tag',
  templateUrl: './provider-profile-tag.component.html',
  styleUrls: ['./provider-profile-tag.component.scss']
})
export class ProviderProfileTagComponent implements OnInit, OnChanges {
  @Input() providerId!: string;
  @Input() providers: any[] = [];
  provider: any;

  ngOnInit() {
    this.getProvider();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.getProvider();
    }
  }

  get hasLogo(): boolean {
    return !!String(this.provider?.logo || '').trim();
  }

  get initial(): string {
    const fname = String(this.provider?.fname || '').trim();
    if (fname) {
      return fname.charAt(0).toUpperCase();
    }
    const name = String(this.provider?.name || '').trim();
    if (name) {
      return name.charAt(0).toUpperCase();
    }
    const lname = String(this.provider?.lname || '').trim();
    return (lname.charAt(0) || '?').toUpperCase();
  }

  getProvider() {
    this.provider = this.providers.filter((el) => el.id === this.providerId)[0];
  }
}
